// C:\Users\cornn\source\repos\purehealthnexus\src\components\Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import '../styles/components/footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <MDBFooter className="text-center text-lg-start text-muted footer-root">
      {/* Top strip: follow & support */}
      <section className="d-flex justify-content-center justify-content-lg-between p-2 border-bottom footer-top-strip">
        <div className="me-3 d-none d-lg-block">
          <span className="follow-support">
            <MDBIcon icon="running" className="me-2" style={{ color: '#333' }} />
            Follow &amp; Support Us:
          </span>
        </div>
      </section>

      {/* Main footer content */}
      <section className="footer-main">
        <MDBContainer className="text-center text-md-start mt-3">
          <MDBRow className="mt-2">
            {/* 1. Brand + affiliate disclaimers */}
            <MDBCol md="4" lg="4" xl="4" className="mx-auto mb-3 footer-column footer-brand-col">
              <h6 className="text-uppercase fw-bold mb-2 footer-heading">
                <MDBIcon color="secondary" icon="heartbeat" className="me-2" />
                Pure Health Nexus
              </h6>

              <p className="disclaimer-title">Amazon Affiliate Disclaimer:</p>
              <p className="disclaimer-text">
                As an Amazon Associate, we earn from qualifying purchases at no extra cost to you.
              </p>

              <p className="disclaimer-title">Product Prices Advertising Disclaimer:</p>
              <p className="disclaimer-text">
                Prices and availability are accurate at the indicated time and may change. The price
                on <span style={{ fontStyle: 'italic' }}>[Amazon site]</span> at purchase applies.
              </p>
            </MDBCol>

            {/* 2. Product links (Amazon-related pages) */}
            <MDBCol md="4" lg="4" xl="4" className="mx-auto mb-3 footer-column footer-products-col">
              <h6 className="text-uppercase fw-bold mb-2 footer-heading">Products</h6>

              <p className="product-link">
                <Link to="/top-rated-vitamins" className="custom-link">
                  Quality Vitamins
                </Link>
              </p>
              <p className="product-link">
                <Link to="/ashwagandha" className="custom-link">
                  Ashwagandha
                </Link>
              </p>
              <p className="product-link">
                <Link to="/lionsmane" className="custom-link">
                  Lion&apos;s Mane
                </Link>
              </p>
              <p className="product-link">
                <Link to="/weightloss" className="custom-link">
                  Weight Loss
                </Link>
              </p>
              <p className="product-link">
                <Link to="/best-whey-protein" className="custom-link">
                  Muscle &amp; Strength
                </Link>
              </p>
              <p className="product-link">
                <Link to="/workout-gear" className="custom-link">
                  Workout Gear
                </Link>
              </p>
              <p className="product-link">
                <Link to="/best-home-gym" className="custom-link">
                  Home Gym
                </Link>
              </p>
            </MDBCol>

            {/* 3. Connect / social */}
            <MDBCol md="4" lg="4" xl="4" className="mx-auto mb-md-0 mb-3 footer-column footer-connect-col">
              <h6 className="text-uppercase fw-bold mb-2 footer-heading">Connect</h6>

              <p>
                <a
                  href="mailto:info@purehealthnexus.com?subject=Product%20info"
                  className="social-icon"
                >
                  <MDBIcon icon="envelope" className="me-2" />
                  Email Us
                </a>
              </p>
              <p>
                <a
                  href="https://www.facebook.com/people/Pure-Health-Nexus/61572572304781/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <MDBIcon fab icon="facebook-f" className="me-2" />
                  Facebook
                </a>
              </p>
              <p>
                <a
                  href="https://www.pinterest.com/PureHealthNexus/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <MDBIcon fab icon="pinterest" className="me-2" />
                  Pinterest
                </a>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      {/* Bottom bar: copyright + legal text */}
      <div className="bottom-bar text-center footer-bottom">
        <p className="mb-1 footer-copy">
          © {currentYear} Asset Legacy. Pure Health Nexus is part of the Asset Legacy family. All
          rights reserved.
        </p>

        <div className="footer-legal">
          {/* 1. Nutrition disclaimer – unchanged */}
          <p className="footer-legal-text">
            The nutrition information and guidance provided on this website are based on your logged
            data and established reference values, and are intended to help you understand your own
            intake. This content is for general information purposes only and is not a substitute for
            personalised medical, nutrition, or other professional advice. Always consult a qualified
            health professional about your individual situation.
          </p>

          {/* 2. Short privacy sentence with link */}
          <p className="footer-legal-text">
            We protect your personal and nutrition data in line with the EU General Data Protection
            Regulation (GDPR) and Swedish law, and we do not sell your data. For details about how we
            use AI, how we keep your profile separate from meal analysis, and your privacy rights,
            please see our{' '}
            <Link to="/privacy" className="custom-link">
              👉 Privacy Policy
            </Link>
            .
          </p>

          {/* 3. Short cookies sentence with link */}
          <p className="footer-legal-text">
            We use cookies and similar technologies to make the site work, remember your settings and
            understand how it is used. You can manage your choices in the cookie banner and your
            browser. Read more in our{' '}
            <Link to="/cookies" className="custom-link">
              👉 Cookie Policy
            </Link>
            .
          </p>
        </div>
      </div>
    </MDBFooter>
  );
}
